import { render, staticRenderFns } from "./switch.vue?vue&type=template&id=e0e50362&scoped=true"
import script from "./switch.vue?vue&type=script&lang=js"
export * from "./switch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0e50362",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0e50362')) {
      api.createRecord('e0e50362', component.options)
    } else {
      api.reload('e0e50362', component.options)
    }
    module.hot.accept("./switch.vue?vue&type=template&id=e0e50362&scoped=true", function () {
      api.rerender('e0e50362', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/utils/switch.vue"
export default component.exports